module.exports = __webpack_public_path__ + "media/21.70b35a24.mp3";